// An invite link (/join/<token>, migration 0016): open it, sign in, and you
// are in. The sign-in form is the drawer's own Account section, and both
// magic link and Google return to this exact URL, so the token survives the
// round trip. Signed in without access, the page redeems the token itself —
// once — and lands home; signed in with access, it just goes home.

import { useEffect, useRef } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { redeemCode, useAuth } from '@/auth/session';
import { AccountSection } from '@/components/AccountSection';
import { APP_ROUTES } from '@/navigation';

export function JoinPage() {
  const { token = '' } = useParams();
  const auth = useAuth();
  const tried = useRef(false);

  useEffect(() => {
    if (auth.status !== 'needsCode' || tried.current || !token) return;
    tried.current = true;
    void redeemCode(token);
  }, [auth.status, token]);

  if (auth.status === 'active' || auth.status === 'unconfigured') {
    return <Navigate replace to={APP_ROUTES.home} />;
  }
  if (auth.status === 'loading') return <div className="sign-in-gate" aria-busy="true" />;

  const joining = auth.status === 'needsCode';
  return (
    <div className="sign-in-gate" data-testid="join-page">
      <div className="sign-in-card">
        <h1>You're invited</h1>
        {!joining ? (
          <>
            <p className="muted">Sign in to join Flat Five.</p>
            <AccountSection />
          </>
        ) : auth.error ? (
          <>
            <p className="home-load-error" role="alert" data-testid="join-error">
              {auth.error}
            </p>
            <p>
              <Link to={APP_ROUTES.home}>Home</Link>
            </p>
          </>
        ) : (
          <p className="muted" data-testid="join-busy">
            Joining…
          </p>
        )}
      </div>
    </div>
  );
}
